"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IRtcEngineExImpl = void 0;
const NATIVE_RTC = __importStar(require("@iris/native-rtc"));
const BaseType_1 = require("../base/BaseType");
const DefaultValue_1 = require("../base/DefaultValue");
const IrisClient_1 = require("../engine/IrisClient");
const IrisClientManager_1 = require("../engine/IrisClientManager");
const IrisClientObserver_1 = require("../engine/IrisClientObserver");
const util_1 = require("../util");
//@ts-ignore
class IRtcEngineExImpl {
    constructor(engine) {
        this._engine = engine;
    }
    joinChannelEx_a3cd08c(token, connection, options) {
        let processJoinChannel = () => __awaiter(this, void 0, void 0, function* () {
            let irisClient = new IrisClient_1.IrisClient(this._engine);
            irisClient.connection = connection;
            irisClient.createClient(options);
            irisClient.irisClientState.token = token;
            let agoraRTCClient = irisClient.agoraRTCClient;
            try {
                yield agoraRTCClient.join(this._engine.globalState.rtcEngineContext.appId, connection.channelId, token ? token : null, connection.localUid);
            }
            catch (reason) {
                util_1.AgoraConsole.error(reason);
                this._engine.rtcEngineEventHandler.onError_d26c0fd(NATIVE_RTC.ERROR_CODE_TYPE.ERR_JOIN_CHANNEL_REJECTED, '');
                // AUDIT-v18: await release per evitare orphan IrisClient in
                // irisClientList. Senza await, il caller può ricevere success prima
                // che lo cleanup sia eseguito.
                try {
                    yield irisClient.release();
                }
                catch (_a) { }
                return this._engine.returnResult(false);
            }
            this._engine.rtcEngineEventHandler.onJoinChannelSuccess_263e4cd(connection, 0);
            if (irisClient.irisClientState.clientRoleType ===
                NATIVE_RTC.CLIENT_ROLE_TYPE.CLIENT_ROLE_BROADCASTER &&
                this._engine.globalState.enabledAudio &&
                options.publishMicrophoneTrack) {
                if (!this._engine.irisClientManager.getLocalAudioTrackPackageBySourceType(BaseType_1.IrisAudioSourceType.kAudioSourceTypeMicrophonePrimary)[0]) {
                    let audioTrack = yield this._engine.implHelper.createMicrophoneAudioTrack();
                    this._engine.irisClientManager.addLocalAudioTrackPackage(new IrisClientManager_1.AudioTrackPackage(BaseType_1.IrisAudioSourceType.kAudioSourceTypeMicrophonePrimary, audioTrack));
                    yield this._engine.trackHelper.setEnabled(audioTrack, true);
                }
            }
            yield this._engine.irisClientManager.irisClientObserver.notifyLocal(IrisClientObserver_1.NotifyType.PUBLISH_TRACK, [
                ...this._engine.irisClientManager.localAudioTrackPackages,
                ...this._engine.irisClientManager.localVideoTrackPackages,
            ], [irisClient]);
            return this._engine.returnResult();
        });
        return this._engine.execute(processJoinChannel);
    }
    leaveChannelEx_c81e1a4(connection) {
        return this.leaveChannelEx_b03ee9a(connection, DefaultValue_1.defaultLeaveChannelOptions);
    }
    leaveChannelEx_b03ee9a(connection, options) {
        let processFunc = () => __awaiter(this, void 0, void 0, function* () {
            if (!options) {
                options = DefaultValue_1.defaultLeaveChannelOptions;
            }
            if (this._engine.irisClientManager.irisClientList.length === 0) {
                return this._engine.returnResult();
            }
            let irisClient = this._engine.irisClientManager.getIrisClientByConnection(connection);
            yield this._engine.irisClientManager.irisClientObserver.notifyLocal(IrisClientObserver_1.NotifyType.UNPUBLISH_TRACK, [
                ...this._engine.irisClientManager.localAudioTrackPackages,
                ...this._engine.irisClientManager.localVideoTrackPackages,
            ]);
            let agoraRTCClient = irisClient === null || irisClient === void 0 ? void 0 : irisClient.agoraRTCClient;
            if (agoraRTCClient) {
                //读取 options
                for (let trackPackage of irisClient.audioTrackPackages) {
                    if (trackPackage.track) {
                        let track = trackPackage.track;
                        if (options.stopMicrophoneRecording) {
                            yield this._engine.trackHelper.setMuted(track, true);
                        }
                    }
                }
                if (options.stopAllEffect) {
                    this._engine.getImplInstance('RtcEngine').stopAllEffects();
                }
                if (options.stopAudioMixing) {
                    //todo audio Mixing
                }
                try {
                    yield this._engine.clientHelper.leave(agoraRTCClient);
                }
                catch (e) {
                    util_1.AgoraConsole.error(e);
                    this._engine.returnResult(false);
                    this._engine.rtcEngineEventHandler.onError_d26c0fd(NATIVE_RTC.ERROR_CODE_TYPE.ERR_LEAVE_CHANNEL_REJECTED, '');
                }
                this._engine.rtcEngineEventHandler.onLeaveChannel_c8e730d(connection, new NATIVE_RTC.RtcStats());
                yield irisClient.release();
            }
            return this._engine.returnResult();
        });
        return this._engine.execute(processFunc);
    }
    updateChannelMediaOptionsEx_457bb35(options, connection) {
        let processInSequence = () => __awaiter(this, void 0, void 0, function* () {
            yield this._engine.implHelper.updateChannelMediaOptions(options, connection);
            return this._engine.returnResult();
        });
        return this._engine.execute(processInSequence);
    }
    setupRemoteVideoEx_522a409(canvas, connection) {
        let processVideoTrack = () => __awaiter(this, void 0, void 0, function* () {
            var _a;
            if ((0, util_1.isDefined)(canvas.uid) && (0, util_1.isDefined)(canvas.view)) {
                let remoteUserPackage = this._engine.irisClientManager.getRemoteUserPackageByUid(canvas.uid);
                // Fix race: con user-account, la UI Dart può ricevere un evento applicativo
                // (es. data stream annunciando uno screen share) e montare AgoraVideoView
                // PRIMA che l'evento Agora user-online crei il pkg remoto. Senza pkg
                // preesistente, il vecchio impl abbandonava silenziosamente e l'element
                // non veniva mai associato — poi il successivo user-online creava un nuovo
                // pkg con element vuoto (vedere IrisClientEventHandler.onEventUserJoined).
                // Pre-creiamo il pkg qui con element già assegnato; il fix in
                // onEventUserJoined troverà alreadyMapped e non toccherà element.
                if (!remoteUserPackage) {
                    remoteUserPackage = new IrisClientManager_1.RemoteUserPackage(connection, canvas.view, DefaultValue_1.defaultRemoteVideoPlayerConfig, canvas.uid, NATIVE_RTC.VIDEO_SOURCE_TYPE.VIDEO_SOURCE_REMOTE, BaseType_1.IrisAudioSourceType.kAudioSourceTypeRemote);
                    let irisClientForAdd = this._engine.irisClientManager.getIrisClientByConnection(connection);
                    this._engine.irisClientManager.addRemoteUserPackage(remoteUserPackage, irisClientForAdd === null || irisClientForAdd === void 0 ? void 0 : irisClientForAdd.agoraRTCClient);
                }
                else {
                    remoteUserPackage.element = canvas.view;
                }
                let irisClient = this._engine.irisClientManager.getIrisClientByConnection(connection);
                if (irisClient) {
                    // Fix user-account mode: remoteUsers[i].uid is string userAccount,
                    // canvas.uid is numeric; compare via _uintid.
                    let remoteUser = (_a = irisClient.agoraRTCClient) === null || _a === void 0 ? void 0 : _a.remoteUsers.find((user) => (0, util_1.getUidFromRemoteUser)(user) === canvas.uid);
                    // subscribe video maybe called before setupVideo, so we need to play video here too
                    if (remoteUser && remoteUser.videoTrack) {
                        this._engine.trackHelper.play(remoteUser.videoTrack, remoteUserPackage.element, remoteUserPackage.videoPlayerConfig);
                    }
                }
                return this._engine.returnResult();
            }
            else {
                return this._engine.returnResult(false, -NATIVE_RTC.ERROR_CODE_TYPE.ERR_INVALID_ARGUMENT);
            }
        });
        return this._engine.execute(processVideoTrack);
    }
    muteRemoteAudioStreamEx_6d93082(uid, mute, connection) {
        let processFunc = () => __awaiter(this, void 0, void 0, function* () {
            let remoteUserPackages = this._engine.irisClientManager.getRemoteUserPackagesByConnection(connection);
            let remoteUsers = remoteUserPackages.filter((userPackage) => {
                return userPackage.uid == uid;
            });
            yield this._engine.irisClientManager.irisClientObserver.notifyRemote(mute
                ? IrisClientObserver_1.NotifyRemoteType.UNSUBSCRIBE_AUDIO_TRACK
                : IrisClientObserver_1.NotifyRemoteType.SUBSCRIBE_AUDIO_TRACK, remoteUsers);
            return this._engine.returnResult();
        });
        return this._engine.execute(processFunc);
    }
    muteLocalAudioStreamEx_3cf17a4(mute, connection) {
        let processFunc = () => __awaiter(this, void 0, void 0, function* () {
            let localAudioTrackPackages = this._engine.irisClientManager.getLocalAudioTrackPackageByConnection(connection);
            yield this._engine.irisClientManager.irisClientObserver.notifyLocal(mute ? IrisClientObserver_1.NotifyType.UNPUBLISH_TRACK : IrisClientObserver_1.NotifyType.PUBLISH_TRACK, localAudioTrackPackages);
            return this._engine.returnResult();
        });
        return this._engine.execute(processFunc);
    }
    muteAllRemoteAudioStreamsEx_3cf17a4(mute, connection) {
        let processFunc = () => __awaiter(this, void 0, void 0, function* () {
            let remoteUserPackages = this._engine.irisClientManager.getRemoteUserPackagesByConnection(connection);
            yield this._engine.irisClientManager.irisClientObserver.notifyRemote(mute
                ? IrisClientObserver_1.NotifyRemoteType.UNSUBSCRIBE_AUDIO_TRACK
                : IrisClientObserver_1.NotifyRemoteType.SUBSCRIBE_AUDIO_TRACK, remoteUserPackages);
            return this._engine.returnResult();
        });
        return this._engine.execute(processFunc);
    }
    muteRemoteVideoStreamEx_6d93082(uid, mute, connection) {
        let processFunc = () => __awaiter(this, void 0, void 0, function* () {
            let remoteUserPackages = this._engine.irisClientManager.getRemoteUserPackagesByConnection(connection);
            let remoteUsers = remoteUserPackages.filter((userPackage) => {
                return userPackage.uid == uid;
            });
            yield this._engine.irisClientManager.irisClientObserver.notifyRemote(mute
                ? IrisClientObserver_1.NotifyRemoteType.UNSUBSCRIBE_VIDEO_TRACK
                : IrisClientObserver_1.NotifyRemoteType.SUBSCRIBE_VIDEO_TRACK, remoteUsers);
            return this._engine.returnResult();
        });
        return this._engine.execute(processFunc);
    }
    muteLocalVideoStreamEx_3cf17a4(mute, connection) {
        let processFunc = () => __awaiter(this, void 0, void 0, function* () {
            let localVideoTrackPackages = this._engine.irisClientManager.getLocalVideoTrackPackageByConnection(connection);
            yield this._engine.irisClientManager.irisClientObserver.notifyLocal(mute ? IrisClientObserver_1.NotifyType.UNPUBLISH_TRACK : IrisClientObserver_1.NotifyType.PUBLISH_TRACK, localVideoTrackPackages);
            return this._engine.returnResult();
        });
        return this._engine.execute(processFunc);
    }
    muteAllRemoteVideoStreamsEx_3cf17a4(mute, connection) {
        let processFunc = () => __awaiter(this, void 0, void 0, function* () {
            let remoteUserPackages = this._engine.irisClientManager.getRemoteUserPackagesByConnection(connection);
            yield this._engine.irisClientManager.irisClientObserver.notifyRemote(mute
                ? IrisClientObserver_1.NotifyRemoteType.UNSUBSCRIBE_VIDEO_TRACK
                : IrisClientObserver_1.NotifyRemoteType.SUBSCRIBE_VIDEO_TRACK, remoteUserPackages);
            return this._engine.returnResult();
        });
        return this._engine.execute(processFunc);
    }
    createDataStreamEx_9f641b6(config, connection) {
        let processFunc = () => __awaiter(this, void 0, void 0, function* () {
            let irisClient = this._engine.irisClientManager.getIrisClientByConnection(connection);
            irisClient.irisClientState.dataStreamConfig = config;
            return this._engine.returnResult();
        });
        return this._engine.execute(processFunc);
    }
    sendStreamMessageEx_0c34857(streamId, data, length, connection) {
        let process = () => __awaiter(this, void 0, void 0, function* () {
            let irisClient = this._engine.irisClientManager.getIrisClientByConnection(connection);
            let agoraRTCClient = irisClient === null || irisClient === void 0 ? void 0 : irisClient.agoraRTCClient;
            if (!(agoraRTCClient === null || agoraRTCClient === void 0 ? void 0 : agoraRTCClient.channelName)) {
                return this._engine.irisRtcErrorHandler.notInChannel();
            }
            else {
                yield this._engine.clientHelper.sendStreamMessage(agoraRTCClient, {
                    payload: data,
                    syncWithAudio: irisClient.irisClientState.dataStreamConfig.syncWithAudio,
                });
            }
            return this._engine.returnResult();
        });
        return this._engine.execute(process);
    }
    setRemoteRenderModeEx_a72fe4e(uid, renderMode, mirrorMode, connection) {
        var _a;
        let config = {
            fit: util_1.AgoraTranslate.NATIVE_RTC_RENDER_MODE_TYPE2Fit(renderMode ? renderMode : NATIVE_RTC.RENDER_MODE_TYPE.RENDER_MODE_FIT),
            mirror: mirrorMode ===
                NATIVE_RTC.VIDEO_MIRROR_MODE_TYPE.VIDEO_MIRROR_MODE_AUTO ||
                mirrorMode ===
                    NATIVE_RTC.VIDEO_MIRROR_MODE_TYPE.VIDEO_MIRROR_MODE_ENABLED,
        };
        let remoteUserPackage = this._engine.irisClientManager.remoteUserPackages.find((user) => {
            return user.uid === uid;
        });
        if (remoteUserPackage) {
            let irisClient = this._engine.irisClientManager.getIrisClientByConnection(connection);
            if (irisClient) {
                // Fix user-account mode: match via _uintid, not string userAccount.
                let user = (_a = irisClient.agoraRTCClient) === null || _a === void 0 ? void 0 : _a.remoteUsers.find((item) => (0, util_1.getUidFromRemoteUser)(item) === remoteUserPackage.uid);
                if (user && user.hasVideo) {
                    remoteUserPackage.videoPlayerConfig = config;
                    if (user.videoTrack) {
                        this._engine.trackHelper.play(user.videoTrack, remoteUserPackage.element, remoteUserPackage.videoPlayerConfig);
                    }
                }
            }
        }
        return this._engine.returnResult();
    }
}
exports.IRtcEngineExImpl = IRtcEngineExImpl;
